export const rootPath = '/';
export const dashboardsPath = 'dashboards';
export const marketAppView = 'marketView/show/dashboard';
export const linksPath = 'v4/dashboards/links';
